export default "__VITE_ASSET__CByhc0Wa__"